import { Injectable } from '@angular/core';
import { Platform } from '@ionic/angular';
import { Capacitor } from '@capacitor/core';
import { Browser } from '@capacitor/browser';
// import { Network, ConnectionStatus } from '@capacitor/network';

import { UtilsService } from './utils.service';
import { UxHelperService } from './uxHelper.service';
import type { TResponse } from '@shared/models';

// import { CallNumber } from '@awesome-cordova-plugins/call-number/ngx';
// import { HttpClient } from '@angular/common/http';
// import { CallNumber } from '@ionic-native/call-number/ngx';
// import { Constants, TCustomer, TSmsType, TRole } from '../index';
// import { Constants, TCustomer, TSmsType, TRole } from '../index';

@Injectable({
    'providedIn': 'root'
})
export class CapacitorService {
    // private onDevice: boolean = false;
    // private device: string;
    private isDesktop: boolean;
    private isMobile: boolean;
    private isMobileWeb: boolean;
    // private networkStatus: ConnectionStatus;

    // private callNumber: CallNumber,
    constructor(private platform: Platform,
        private uxHelperService: UxHelperService, private utilsService: UtilsService) {
        // this.onDevice = this.platform.is('mobileweb') || this.platform.is('mobile');
        // this.device = Capacitor.getPlatform();
        this.isDesktop = this.platform.is('desktop');
        this.isMobile = this.platform.is('mobile');
        this.isMobileWeb = this.platform.is('mobileweb');
        // console.log('isDesktop   = ' + this.isDesktop);
        // console.log('isMobile    = ' + this.isMobile);
        // console.log('isMobileWeb = ' + this.isMobileWeb);
    }

    // public async foo() {
    //     this.networkStatus = await Network.getStatus();

    //     Network.addListener('networkStatusChange', status => {
    //         this.networkStatus = status;
    //     });
    // }

    public get runningOnDesktopDevice(): boolean {
        // return (this.device === 'web');
        return this.isDesktop;
    }

    public get runningOnMobileDevice(): boolean {
        // return (this.device === 'android' || this.device === 'ios');
        return (this.isMobile || this.isMobileWeb);
    }

    public async callPrompt(phoneNumber: string, name = ''): Promise<void> {
        try {
            let resp: TResponse;
            // console.log('this.device = ' + this.device);
            // if (this.runningOnDesktopDevice) {
            //     await this.uxHelperService.showAlert('Error', 'Must be on a phone to make a call.');
            //     return;
            // }
            const whom = (name) ? name : phoneNumber;
            const msg = 'Are you sure you want to call: ' + whom + '?';
            const response = await this.uxHelperService.showAlert('Confirm Call', msg);
            if (response.okay) {
                // The dialer wants phone numbers in very specific format.
                // For example, convert this phone number '6618778631' into this 'tel:+16618778631'
                const cellPhone = this.utilsService.formatPhoneNumberForDialer(phoneNumber);

                const phoneCaller = document.getElementById('phoneCaller');
                if (phoneCaller) {
                    phoneCaller.setAttribute('href', cellPhone || '');
                    phoneCaller.click();
                    phoneCaller.setAttribute('href', '');
                }

                // const callNumber = new CallNumber();
                // const resp2 = await this.callNumber.callNumber(phoneNumber, false );

                // const resp2 = await CallNumber.callNumber(phoneNumber, false );
                // this.callNumber.callNumber(cellPhone, false ).then(resp2 => {
                //     console.log(resp2);
                // }).catch(err => {
                //     console.log(err);
                // })

                // const resp2 = await callNumber.callNumber(phoneNumber, false );
                // console.log(resp2);
            }
        } catch (err) {
            const errorMessage = this.utilsService.extractError(err);
            await this.uxHelperService.showAlert('Error', errorMessage);
        }
    }

    public async openWebsite(): Promise<void> {
        const url = 'https://www.shuttlenomix.com';
        return this.openUrl(url);
    }

    public async openUrl(url: string): Promise<void> {
        return await Browser.open({ 'url': url });
    }
}
